import Lottie from 'lottie-react';
import React, { useMemo } from 'react';
import Modal from 'react-modal';

import { useSystemColourPreference } from '../../../hooks/useSystemColourPreference';
import styles from './SharedAdmin.module.scss';
import { getLottieAnimation, LottieAntimationTypes } from '../../../assets/lottie/getLottieAnimation';

interface RecalculatingModalProps {
    buttons: JSX.Element
}

export const RecalculatingModal: React.FC<RecalculatingModalProps> = ({ buttons }) => {
    const showDarkTheme = useSystemColourPreference();
    const animationToUse = useMemo(() => getLottieAnimation(LottieAntimationTypes.ARK_LOADING, showDarkTheme), [showDarkTheme]);
    return (
        <Modal
            ariaHideApp={false}
            isOpen
            className={styles.recalculatingModal}
            style={{ overlay: { display: 'flex', zIndex: 10 } }}
        >
            <div className={styles.spinnerWrapper}>
                <div className={styles.spinner}>
                    <Lottie animationData={animationToUse} loop />
                </div>
                <div className={styles.recalculatingWarning}>
                    <div>Changes to your Dataset Field / Risk Tolerance configuration have been made and your document risk score is currently being recalculated.</div>
                    <div>While this is being completed you are unable to make any further changes to this agreement type.</div>
                    <div style={{ fontSize: '20px' }}>This could take a while...</div>
                </div>
            </div>
            <div className={styles.recalculatingButtonWrapper}>{buttons}</div>
        </Modal>
    );
};
